import { useState } from "react";
import { Plus, Edit, Trash, RefreshCcw } from "lucide-react";
import AddTagModal from "../AddTagModal";
import tagApi from "../../../../api/tagApi.js";
import { useNotification } from "../../../../hooks/useNotification.jsx";

export default function ManageTagModal({ shop, tags, setTags }) {
  const { addNotification } = useNotification();

  const [showColorOnly, setShowColorOnly] = useState(false);
  const [showAddModal, setShowAddModal] = useState(false);
  const [editingTag, setEditingTag] = useState(null);

  const getTags = async () => {
    const res = await tagApi.getByShopId(shop?._id);
    if (res.status === 1) setTags(res.data);
  };

  const handleChangeActiveClick = async (tag) => {
    const res = await tagApi.updateByIds([{ ...tag, isActive: !tag.isActive }]);
    if (res.status === 1) await getTags();
  };

  const handleEditClick = (tag) => {
    setEditingTag(tag);
    setShowAddModal(true);
  };

  const handleDeleteClick = async (tag) => {
    if (!window.confirm(`Bạn có muốn xoá tag ${tag.name} không?`)) return;
    const res = await tagApi.updateByIds(
      tags.map((t) => {
        if (t._id === tag._id) {
          return {
            ...t,
            isDelete: true,
          };
        } else {
          if (t.ordinalNumber > tag.ordinalNumber)
            return {
              ...t,
              ordinalNumber: t.ordinalNumber - 1,
            };
          else return t;
        }
      })
    );
    if (res.status === 1) {
      await getTags();
      addNotification("Xoá thành công", res.status);
    } else addNotification(res.message, res.status);
  };

  return (
    <>
      <div className="h-full flex items-center justify-center overflow-y-auto">
        <div className="w-full h-full">
          <div className="h-full grid md:grid-cols-2 gap-6">
            {/* Left Panel */}
            <div className="bg-gray-50 rounded-lg p-6 border border-1">
              <h3 className="text-lg font-medium mb-4 text-gray-700 border-b pb-2">
                Cài đặt tag
              </h3>
              <div className="flex items-center gap-3">
                <input
                  type="checkbox"
                  id="colorOnly"
                  checked={showColorOnly}
                  onChange={(e) => setShowColorOnly(e.target.checked)}
                  className="w-5 h-5 text-blue-600 rounded focus:ring-blue-500"
                />
                <label htmlFor="colorOnly" className="text-gray-700">
                  Chỉ hiển thị màu sắc
                </label>
              </div>
              <p className="text-sm text-gray-500 mt-2">
                (Mặc định là hiển thị tên + màu)
              </p>
            </div>

            {/* Right Panel */}
            <div className="bg-white rounded-lg border border-1">
              <div className="p-4 border-b">
                <button
                  onClick={() => setShowAddModal(true)}
                  className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg flex items-center gap-2 transition-colors duration-200"
                >
                  <Plus size={20} />
                  Thêm
                </button>
              </div>

              <div className="overflow-auto">
                <table className="w-full border-collapse">
                  <thead>
                    <tr className="bg-gray-100 text-gray-700">
                      <th className="px-4 py-3 text-left">STT</th>
                      <th className="px-4 py-3 text-left">Tag</th>
                      <th className="px-4 py-3 text-left">Trạng thái</th>
                      <th className="px-4 py-3 text-left">Hành động</th>
                    </tr>
                  </thead>
                  <tbody>
                    {tags.map((row, index) => (
                      <tr
                        key={row._id}
                        className="border-t hover:bg-gray-50 transition-colors duration-200"
                      >
                        <td className="px-4 py-3">{row.ordinalNumber}</td>
                        <td className="px-4 py-3">
                          <div className="flex items-center gap-3">
                            <div
                              className="w-6 h-6 rounded-full shadow-inner"
                              style={{ backgroundColor: row.color }}
                            />
                            <span className="font-medium text-gray-700">
                              {row.name}
                            </span>
                          </div>
                        </td>
                        <td className="px-4 py-3">
                          <span
                            className={`px-2 py-1 rounded-full text-xs font-medium ${
                              row.isActive === "Hoạt động"
                                ? "bg-green-100 text-green-800"
                                : "bg-red-100 text-red-800"
                            }`}
                          >
                            {row.isActive ? "Hoạt động" : "Không hoạt động"}
                          </span>
                        </td>
                        <td className="px-4 py-3">
                          <div className="flex items-center gap-2">
                            <button
                              className="text-gray-600 hover:text-gray-800"
                              title="Đổi trạng thái"
                              onClick={() => handleChangeActiveClick(row)}
                            >
                              <RefreshCcw size={18} />
                            </button>
                            <button
                              className="text-blue-600 hover:text-blue-800"
                              title="Sửa"
                              onClick={() => handleEditClick(row)}
                            >
                              <Edit size={18} />
                            </button>
                            <button
                              className="text-red-600 hover:text-red-800"
                              title="Xóa"
                              onClick={() => handleDeleteClick(row)}
                            >
                              <Trash size={18} />
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <AddTagModal
        isOpen={showAddModal}
        setIsOpen={setShowAddModal}
        shop={shop}
        editingTag={editingTag}
        setEditingTag={setEditingTag}
        tags={tags}
        getTags={getTags}
      />
    </>
  );
}
